import { ReactElement } from 'react';
import { useIsDraft } from '../ContextProviders/AppContext';
import { CategoryNavEdit } from './CategorySort/CategoryNavEdit';
import { CategoryNavPublish } from './CategoryNavPublish';

export const CategoryNav = ({ id }: { id: string }): ReactElement => {
  const [isDraft] = useIsDraft();
  return isDraft ? <CategoryNavEdit id={id} key={id} /> : <CategoryNavPublish id={id} key={id} />;
};
